export default class WebSocketMessageResponse {
    constructor(
        public time ?: number,
        public messageType ?: string,
        public userType ?: string,
        public content ?: string,
        public name ?: string,
        public username ?: string,
        public messages ?: Record<string, WebSocketMessageResponse>,
        public topicId ?: number,
        public listener ?: string,
        public error ?: boolean,
        public messageAttempt ?: number,
        public classId?: string
    ){}
}